export { FindReplaceComponent } from './find-replace.component';
